import { useFormikContext } from 'formik'
import { ChangeEvent, FC, useMemo } from 'react'
import { VinciInput } from '~/components'
import { ICustomAssetExtraField } from '~/tmp/assetTypes/extra_fields'
import { ICustomAssetInspectionSubmitValues } from '../create-custom-asset-audit'

interface ICustomFieldProps {
  field: ICustomAssetExtraField
}
export const CustomField: FC<ICustomFieldProps> = ({ field }) => {
  const formik = useFormikContext<ICustomAssetInspectionSubmitValues>()

  const defaultProps = useMemo(
    () => ({
      name: `extra_fields.${field.field}`,
      label: field.name,
      fullWidth: true,
      // value: formik.values.extra_fields[field.field],
      defaultValue: formik.values.extra_fields[field.field],
      onChange: (e: ChangeEvent<HTMLInputElement>) => {
        formik.handleChange(e)
      },
    }),
    [field],
  )

  if (field.type === 'string') return <VinciInput {...defaultProps} />
  if (field.type === 'number')
    return (
      <VinciInput
        {...defaultProps}
        onKeyDown={(e) => {
          if (!/\d/.test(e.key)) {
            e.preventDefault()
          }
        }}
      />
    )
  if (field.type === 'zip_code')
    return (
      <VinciInput
        {...defaultProps}
        inputProps={{ maxlength: 5 }}
        onKeyDown={(e) => {
          const isNotNumber = !/\d/.test(e.key)
          if (isNotNumber) {
            e.preventDefault()
          }
        }}
      />
    )

  return null
}
